export function dumpCSV(data: any[][]): string {
  return data.map((row) => row.join(",")).join("\n");
}
